'use client';
import React from 'react';
export type KPITone = 'positive' | 'negative' | 'neutral';

export interface KPIBoxProps {
  label: React.ReactNode;
  value: string;
  valueTone?: KPITone;
  sub?: string;
  subTone?: KPITone;
  footer?: React.ReactNode;
}

const VALUE_TONE_CLASS: Record<KPITone, string> = {
  positive: 'text-green-600',
  negative: 'text-red-600',
  neutral: 'text-gray-700',
};

const SUB_TONE_CLASS: Record<KPITone, string> = {
  positive: 'text-green-600',
  negative: 'text-red-600',
  neutral: 'text-gray-500',
};

export const kpiToneFromBool = (flag: boolean | null | undefined): KPITone | undefined => {
  if (flag === true) return 'positive';
  if (flag === false) return 'negative';
  return undefined;
};

export const KPIBox: React.FC<KPIBoxProps> = ({ label, value, valueTone, sub, subTone, footer }) => (
  <div className="flex flex-col gap-0.5 rounded border border-[#e9ecef] bg-white px-4 py-3">
    <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">{label}</p>
    <p className={`text-lg font-bold leading-tight ${valueTone ? VALUE_TONE_CLASS[valueTone] : 'text-gray-900'}`}>
      {value}
    </p>
    {sub && <p className={`text-xs font-medium ${SUB_TONE_CLASS[subTone ?? 'neutral']}`}>{sub}</p>}
    {footer ? <div className="text-xs text-gray-400">{footer}</div> : null}
  </div>
);

export default KPIBox;
